import { render, staticRenderFns } from "./ComponentMaker.vue?vue&type=template&id=38aec3c2"
import script from "./ComponentMaker.vue?vue&type=script&lang=js"
export * from "./ComponentMaker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports